<template>
  <validation-observer v-slot="{ invalid }">
    <form @submit.prevent="handleSubmit">
      <validation-provider name="Supplier" v-slot="context" rules="required">
        <multi-select
          v-model="supplier"
          placeholder="Pick a supplier"
          track-by="id"
          label="invoice_legal_name"
          :options="suppliers"
          :internal-search="false"
          @search-change="debouncedFunction"
        />

        <small v-if="context.errors.length" v-bind="context.ariaMsg" class="text-danger form-text">
          {{ context.errors[0] }}
        </small>
      </validation-provider>

      <template v-if="supplier">
        <hr />

        <validation-provider name="Code Batch Name" v-slot="context" rules="required">
          <b-form-group label="Code Batch Name">
            <b-form-input
              v-model="title"
              placeholder="e.g Lorem Ipsum"
              :state="getValidationState(context)"
              v-bind="context.ariaInput"
            />

            <b-form-invalid-feedback v-bind="context.ariaMsg">
              {{ context.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <hr />

        <b-row>
          <b-col>
            <validation-provider name="End Time" v-slot="context" rules="required">
              <b-form-group label="End Time">
                <b-form-datepicker
                  locale="nb-NO"
                  :start-weekday="1"
                  v-model="end_time"
                  :state="getValidationState(context)"
                  v-bind="context.ariaInput"
                />

                <b-form-invalid-feedback v-bind="context.ariaMsg">
                  {{ context.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col>
            <validation-provider name="Alert When" v-slot="context" rules="required">
              <b-form-group label="Alert When (Remaining Codes)">
                <b-form-input
                  v-model="alert_when"
                  placeholder="e.g 1"
                  :state="getValidationState(context)"
                  v-bind="context.ariaInput"
                />

                <b-form-invalid-feedback v-bind="context.ariaMsg">
                  {{ context.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <validation-provider name="Codes" v-slot="context" rules="required">
          <b-form-group label="Codes">
            <b-textarea
              v-model="codes"
              placeholder="e.g A 1212121212"
              :state="getValidationState(context)"
              v-bind="context.ariaInput"
            />

            <b-form-invalid-feedback v-bind="context.ariaMsg">
              {{ context.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <b-row align-h="end">
          <b-col cols="auto">
            <b-button type="submit" variant="primary" :disabled="$cannot('supplier.manage') || invalid"> Add </b-button>
          </b-col>
        </b-row>
      </template>
    </form>
  </validation-observer>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css'
import MultiSelect from 'vue-multiselect'
import {getValidationState} from '../page-helpers'
import {products, suppliers} from '@/api'
import {debounce} from "ts-debounce";

export default {
  name: 'CSVCodesBatchForm',
  inject: ['$cannot'],
  components: { MultiSelect },

  beforeMount() {
    this.findSupplier('')
  },

  data() {
    return {
      suppliers: [],
      supplier: null,

      codes: '',
      alert_when: 1,
      end_time: '',
      title: '',

      debouncedFunction: debounce(this.findSupplier, 300)
    }
  },

  methods: {
    getValidationState,

    findSupplier(text) {
      suppliers.all({filter: {search: text}})
      .then((res) => {
        this.suppliers = res.data()
        this.$forceUpdate();
      })
    },

    async handleSubmit() {
      await this.$store.dispatch('auth/refreshToken');
      await products.variations.batches.create({
          codes: this.codes,
          alert_when: this.alert_when,
          end_time: this.end_time,
          title: this.title,
          supplier_id: this.supplier.id,
        }
      )

      this.$bvToast.toast(`Codes for supplier uploaded.`, {
        title: 'Code batch uploaded',
        variant: 'primary',
      })

      this.$emit('close')
    },
  },
}
</script>
